// extracted by mini-css-extract-plugin
export var productImage = "_ne-1";
export var viewLink = "_ne-2";
export var wishlistItem = "_ne-0";